module.exports = __webpack_public_path__ + "static/img/feature_settings.d9531f74.png";